import PropTypes from 'prop-types';
import { useEffect, useRef, useState, useCallback } from 'react';
import { useGlobals, useOnClickOutside } from '@bwoty-web/ui-kit/hooks';
import { Icon, TextInput } from '@bwoty-web/ui-kit';
import { ICON_UI_CLOSE, ICON_UI_SEARCH } from '@bwoty-web/ui-kit/icons';
import cx from 'classnames';

import './globeSearch.scss';

const GlobeSearch = ({ isOpen, onClose }) => {
  const [searchTerm, setSearchTerm] = useState('');
  const overlayRef = useRef(null);
  const { content } = useGlobals();

  const handleCancel = useCallback(() => {
    onClose();
    setSearchTerm('');
  }, [onClose]);

  useEffect(() => {
    const handleEscapeKeyPress = (event) => {
      if (event.key === 'Escape') handleCancel();
    };
    window.addEventListener('keydown', handleEscapeKeyPress);
    return () => {
      window.removeEventListener('keydown', handleEscapeKeyPress);
    };
  }, [handleCancel, isOpen]);

  useOnClickOutside(overlayRef, () => onClose(), isOpen);

  const handleChange = (event) => {
    setSearchTerm(event.target.value);
  };

  const handleSubmit = (event) => {
    event.preventDefault();
    const searchParams = new URLSearchParams();

    if (searchTerm) {
      searchParams.set('q', encodeURIComponent(searchTerm));
    }

    const newUrl = `${
      content?.searchLink?.href?.url
    }?${searchParams.toString()}`;
    window.location.href = newUrl;
  };

  return (
    <form
      ref={overlayRef}
      className={cx('header-search-box', {
        'header-search-box--active': isOpen,
      })}
      onSubmit={handleSubmit}
    >
      <button type="submit">
        <Icon path={ICON_UI_SEARCH} size="s" />
        <span className="visually-hidden">
          {content?.searchLabel || 'Search'}
        </span>
      </button>
      <div className="header-search-box__field">
        <TextInput
          type="search"
          className="header-search-box__field"
          placeholder={`${content?.searchPlaceholder || 'Search'}`}
          value={searchTerm}
          onChange={handleChange}
        />
      </div>
      <button
        type="button"
        onClick={handleCancel}
        className="header-search-box__back-button"
        aria-expanded={isOpen}
      >
        <Icon path={ICON_UI_CLOSE} size="s" aria-hidden="true" />
        <span className="visually-hidden">
          {content?.cancelLabel || 'Back'}
        </span>
      </button>
    </form>
  );
};

GlobeSearch.propTypes = {
  isOpen: PropTypes.bool,
  onClose: PropTypes.func.isRequired,
};

GlobeSearch.defaultProps = {
  isOpen: false,
};

export default GlobeSearch;
